module.exports = __webpack_public_path__ + "img/DSCN4217.18fbede6.jpg";